import React, { useState } from "react";
import { SAdefaultValues } from "./accountingRPT-services";
import {
  Button,
  colors,
  Container,
  Grid,
  LinearProgress,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import AccountingRPTForm from "./accountingRPT-form";
import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import {
  useStylesUiElemment,
} from "../../../../St/Reports/UseStyle";
import BalanceCard from "../../../../components/BalanceCard";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { TableChart } from "@material-ui/icons";
import axios from "axios";
import AccountsSumTable from "./AccountSumTable";
import AccountsRPTTable from "./AccountsRPTTable";
import InvoicesDialogs from "../../../Invs/BackEnd/Invoices/InvoicesDialogs";
import EReceiptVoucherDialog from "../receipt-voucher/external-receipt-voucher/EReceiptVoucherDialog";
import EExchangeVoucherDialog from "../receipt-voucher/external-exchange-voucher/EExchangeVoucherDialog";
import IExchangeVoucherDialog from "../receipt-voucher/internal-exchange-voucher/IExchangeVoucherDialog";
import ReceiptVoucherDialog from "../receipt-voucher/internal-receipt-voucher/ReceiptVoucherDialog";
import ORestrictionsDialog from "../opening-restrictions/ORestrictionsDialog";
import { MultiQabdDataDialog, MultiSarfDataDialog } from "../receipt-voucher/multi-receipt-voucher/MVCon";
import RestrictionDailogCon from "../Restriction/RestrictionDailogCon";
import RestInfoDialog from "../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { GetItemFromOptions } from "../../../../services/multi-receipt-services";
import RevAccounting from "../../../../Reviews/Accounts/Balance/RevAccounting";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    borderColor: "#808080",
    textAlign: "center",
    fontSize: 20,
    width: "100%",
    fontWeight: "bold"
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
}));
export const getExcelHeadersAccount = (t) => [
  { label: t("balance"), key: "balance" },
  { label: t("dept"), key: "dept" },
  { label: t("credit"), key: "credit" },
  { label: t("doc-no"), key: "doc_no" },
  { label: t("center"), key: "centerName" },
  { label: t("date"), key: "date" },
  { label: t("doc-type"), key: "type" },
  { label: t("ref-no"), key: "ref_no" },
  { label: t("note"), key: "notes" },
];
export default function AccountingRPT(props) {
  const { AutoOptions, accounts } = props;
  const { t } = useTranslation(["forms"]);
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";

  const typePrint = [
    { id: 0, label: t("default"), key: "balance" },
    { id: 1, label: t("account-auth"), key: "dept" },
  ];
  const [rptParams, setRptParams] = React.useState({
    ...SAdefaultValues,
    dateFrom: from_date,
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    account: AutoOptions.Accindex[0],
    typePrint: typePrint[0]
  });

  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const [dataExcel, setDataExcel] = useState([]);
  const [dataTotals, setDataTotals] = useState({});
  const [invData, setInvData] = useState({});
  const [accountsName, setAccountsName] = useState({});
  const [fetching, setFetching] = useState(false);
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const [infoData, setInfoData] = useState({ open: false, rest_id: 0, branch: 0 });
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };

  const viewHandle = async () => {
    setDataExcel([]);
    setDataTotals({});
    setFetching(true);
    if (rptParams.selectType.id == 1) {

      await axios
        .get(
          uri +
          `AccountReports/rptAccBalance?acc_no=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account.id}
    &&dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center?.id}
    &&openBalance=${rptParams.openBalance}
    &&oldBalance=${rptParams.oldBalance}
    &&orderType=${rptParams.orderType.id}
    &&docType=${rptParams.docType.id}
    &&omla=${rptParams.omla.id}`
        )
        .then((res) => {
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          setFetching(false);
          console.log(err);
          setDataTotals({});
          setDataExcel([]);
          // toast.err(t("fetch-error"));
        });
    } else {
      await axios
        .get(
          uri +
          `AccountReports/AccountsSumDataMulti?type=${rptParams.type?.id}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center?.id}
    &&dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&acc_code=${rptParams?.selectTypeSearch?.id == 2 ? rptParams.accountMlti : rptParams.account?.id}
           &&old=${rptParams?.oldBalance}
        &&open=${rptParams?.openBalance}`
        )
        .then((res) => {
          // setData(res.data);
          const dataItems = res.data.AccountBalance.map((row, i) => {
            return {
              ...row,
              no: i + 1,
              centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
            };
          });
          setDataExcel(dataItems);
          setDataTotals(res.data.totals);
          // console.log(" the data is", res.data);
          setFetching(false);
        })
        .catch((err) => {
          viewHandleOld();
        });
    }
  };
  const viewHandleOld = async () => {
    await axios
      .get(
        uri +
        `AccountReports/AccountsSumData?type=${rptParams.type?.id}
&&branch=${rptParams.branch.id}
&&center=${rptParams.center?.id}
&&dateFrom=${rptParams.dateFrom}
&&dateTo=${rptParams.dateTo}
&&acc_code=${rptParams.account?.id}`
      )
      .then((res) => {
        const dataItems = res.data.AccountBalance.map((row, i) => {
          return {
            ...row,
            no: i + 1,
            centerName: GetItemFromOptions(row?.center == -1 ? null : row?.center, AutoOptions?.center ?? [])?.name ?? "",
          };
        });
        setDataExcel(dataItems);
        setDataTotals(res.data.totals);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        setDataTotals({});
        setDataExcel([]);
      });
  };
  const his = useHistory();
  const toBack = () => {
    his.push({ pathname: "/" });
  };
  const printHandle = () => {
    if (dataExcel.length == 0) return;
    if (rptParams.typePrint.id == 1 && rptParams?.selectTypeSearch?.id == 1) {
      printHandleConfirm();
    } else {
      if (rptParams.selectType.id == 1) {
        const info = {
          data: dataExcel,
          tot: dataTotals,
          from: t("account"),
          title: t("acc-move-period"),
          auto: {},
          account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
          fDate: rptParams.dateFrom,
          tDate: rptParams.dateTo,
          balance: parseFloat(dataTotals?.totBlncDept ?? 0)
            - parseFloat(dataTotals?.totBlncCredit ?? 0),
          cust: rptParams.account,
          fDate: rptParams.dateFrom,
          tDate: rptParams.dateTo,
          nDate: moment(new Date()).format("YYYY-MM-DD"),
          ElmntShow: true,
          isConfirem: false,
        };
        setDataPrint(info);
        setInfoPrint(true);
      } else {
        printHandleSum();
      }
    }
  };

  const printHandleConfirm = () => {
    const info = {
      balance: parseFloat(dataTotals?.totBlncDept ?? 0)
        - parseFloat(dataTotals?.totBlncCredit ?? 0),
      from: t("account"),
      title: t("account-auth-request"),
      auto: {},
      cust: rptParams.account,
      fDate: rptParams.dateFrom,
      tDate: rptParams.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      date: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
      isConfirem: true,
    };
    setDataPrint(info);
    setInfoPrint(true);
  };
  const printHandleSum = () => {
    const info = {
      data: dataExcel,
      tot: dataTotals,
      type: rptParams?.type?.id,
      kind_print: "2",
      title: t("acc-move-period"),
      title: t("acc-move-period"),
      account: rptParams?.selectTypeSearch?.id == 2 ? rptParams?.accountMlti : rptParams.account,
      fDate: rptParams?.dateFrom,
      tDate: rptParams?.dateTo,
      nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: true,
    };
    localStorage.setItem('iInfos', JSON.stringify(info));
    his.push({ pathname: "/CustBalance", state: info });
    window.location.reload(false);
  };
  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  };
  const [isOpenInv, setIsOpenInv] = useState(false);
  const [isOpenSandQ, setIsOpenSandQ] = useState(false);
  const [isOpenSandS, setIsOpenSandS] = useState(false);
  const [isOpenSandSD, setIsOpenSandSD] = useState(false);
  const [isOpenSandQD, setIsOpenSandQD] = useState(false);
  const [isOpenDailyRest, setIsOpenDailyRest] = useState(false);
  const [isOpenFirstRest, setIsOpenFirstRest] = useState(false);
  const [isOpenMultiSarf, setIsOpenMultiSarf] = useState(false);
  const [isOpenMultiQbd, setIsOpenMultiQbd] = useState(false);



  const [allow, setAllow] = useState({ inv: false, sqbd: false, sandQD: false, ssrf: false, sandSD: false, dailyRes: false, FirstRest: false, multiSarf: false, multiQbd: false });
  const handleOpenInvData = () => {
    setAllow({ ...allow, inv: !isOpenInv });
    setIsOpenInv(!isOpenInv);
  }; // E rsa

  const handleOpenSandQData = () => {
    setAllow({ ...allow, sqbd: !isOpenSandQ });
    setIsOpenSandQ(!isOpenSandQ);
  }; // E rsa
  const handleOpenSandSData = () => {
    setAllow({ ...allow, ssrf: !isOpenSandS });
    setIsOpenSandS(!isOpenSandS);
  }; // E rsa
  const handleOpenSandSDData = () => {
    setAllow({ ...allow, sandSD: !isOpenSandSD });
    setIsOpenSandSD(!isOpenSandSD);
  }; // E rsa
  const handleOpenSandQDData = () => {
    setAllow({ ...allow, sandQD: !isOpenSandQD });
    setIsOpenSandQD(!isOpenSandQD);
  }; // E rsa
  const handleOpenDailyRest = () => {
    setAllow({ ...allow, dailyRes: !isOpenDailyRest });
    setIsOpenDailyRest(!isOpenDailyRest);
  }; // E rsa
  const handleOpenFirstRest = () => {
    setAllow({ ...allow, FirstRest: !isOpenFirstRest });
    setIsOpenFirstRest(!isOpenFirstRest);
  }; // E rsa
  const handleOpenMultiSarf = () => {
    setAllow({ ...allow, multiSarf: !isOpenMultiSarf });
    setIsOpenMultiSarf(!isOpenMultiSarf);
  }; // E rsa

  const handleOpenMultiQbd = () => {
    setAllow({ ...allow, multiQbd: !isOpenMultiQbd });
    setIsOpenMultiQbd(!isOpenMultiQbd);
  }; // E rsa
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("acc-move-period")}
        </Typography>
      </Grid>
      <Typography component="div" style={{ direction: "rtl" }}>
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            borderBottomColor: colors.indigo[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <AccountingRPTForm
            {...{
              AutoOptions,
              rptParams,
              setRptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
              accounts,
              setAccountsName,
              accountsName,
              typePrint
            }}
          />
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1}>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                color="primary"
                size="large"
                className={clasui.buttonAcc}
                // onClick={() => fetchURL()}
                onClick={() => viewHandle()}
              >
                {t("view")}{" "}
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={clasui.buttonAcc}
                onClick={printHandle}
              >
                {t("print")}{" "}
              </Button>
            </Grid>
            <Grid item>
              {dataExcel && !fetching && (
                <CSVLink
                  separator={";"}
                  filename={"AccountsReports"}
                  data={dataExcel}
                  headers={getExcelHeadersAccount(t)}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    color="primary"
                    size="large"
                    className={clasui.buttonAcc}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                style={{ background: "#b71c1c" }}
                className={clasui.button}
                onClick={toBack}
              >
                {t("exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={4} md={4} sm={4} xs={6}>
              {rptParams.selectType.id == 1 ?
                (<BalanceCard
                  {...{
                    title: t("acc-peroid-balance"),
                    dept: dataTotals?.totBlncDept ?? 0,
                    credit: dataTotals?.totBlncCredit ?? 0,
                  }}
                />)
                : (<BalanceCard
                  {...{
                    title: t("acc-peroid-balance"),
                    dept: dataTotals?.totEndDept ?? 0,
                    credit: dataTotals?.totEndCredit ?? 0,
                  }}
                />)}

            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={6}>
              {rptParams.selectType.id == 1 ?
                (<BalanceCard
                  {...{
                    title: t("acc-peroid-total"),
                    dept: dataTotals?.totDept ?? 0,
                    credit: dataTotals?.totCredit ?? 0,
                  }}
                />) : (<BalanceCard
                  {...{
                    title: t("acc-peroid-total"),
                    dept: dataTotals?.totDept ?? 0,
                    credit: dataTotals?.totCredit ?? 0,
                  }}
                />)}
            </Grid>
          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            marginTop: "0.4rem"
          }}
        >
          <Grid container>
            {rptParams.selectType.id == 1 ?
              (fetching ? (
                <Paper>
                  {t("please-wait-fetch-data")}
                  <LinearProgress />
                </Paper>
              ) : (
                <AccountsRPTTable
                  {...{
                    data: dataExcel ? dataExcel : [], setInvData, handleOpenInvData, handleOpenSandQData, handleOpenSandSData
                    , handleOpenSandSDData, handleOpenSandQDData, handleOpenDailyRest, handleOpenFirstRest,
                    handleOpenMultiSarf, handleOpenMultiQbd, infoData, setInfoData, AutoOptions
                  }}
                />
              )) :
              (fetching ? (
                <Paper>
                  {t("please-wait-fetch-data")}
                  <LinearProgress />
                </Paper>
              ) : (
                <AccountsSumTable {...{ data: dataExcel ? dataExcel : [] }} />
              ))}
          </Grid>

        </Container>
        {
          allow.inv ? (
            <InvoicesDialogs
              open={isOpenInv}
              onClose={() => {
                setIsOpenInv(false);
              }}
              onSave={() => {
                setIsOpenInv(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.sqbd ? (
            <EReceiptVoucherDialog
              open={isOpenSandQ}
              onClose={() => {
                setIsOpenSandQ(false);
              }}
              onSave={() => {
                setIsOpenSandQ(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.ssrf ? (
            <EExchangeVoucherDialog
              open={isOpenSandS}
              onClose={() => {
                setIsOpenSandS(false);
              }}
              onSave={() => {
                setIsOpenSandS(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.sandSD ? (
            <IExchangeVoucherDialog
              open={isOpenSandSD}
              onClose={() => {
                setIsOpenSandSD(false);
              }}
              onSave={() => {
                setIsOpenSandSD(false);
              }}
              invData={invData}
            />
          ) : null}

        {
          allow.sandQD ? (
            <ReceiptVoucherDialog
              open={isOpenSandQD}
              onClose={() => {
                setIsOpenSandQD(false);
              }}
              onSave={() => {
                setIsOpenSandQD(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.dailyRes ? (
            <RestrictionDailogCon
              open={isOpenDailyRest}
              onClose={() => {
                setIsOpenDailyRest(false);
              }}
              onSave={() => {
                setIsOpenDailyRest(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.FirstRest ? (
            <ORestrictionsDialog
              open={isOpenFirstRest}
              onClose={() => {
                setIsOpenFirstRest(false);
              }}
              onSave={() => {
                setIsOpenFirstRest(false);
              }}
              invData={invData}
            />
          ) : null}
        {
          allow.multiSarf ? (
            <MultiSarfDataDialog
              open={isOpenMultiSarf}
              onClose={() => {
                setIsOpenMultiSarf(false);
              }}
              onSave={() => {
                setIsOpenMultiSarf(false);
              }}
              invData={invData}
            />
          ) : null}

        {
          allow.multiQbd ? (
            <MultiQabdDataDialog
              open={isOpenMultiQbd}
              onClose={() => {
                setIsOpenMultiQbd(false);
              }}
              onSave={() => {
                setIsOpenMultiQbd(false);
              }}
              invData={invData}
            />
          ) : null}
        {infoData.open &&
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={infoData.rest_id}
            branch={infoData.branch}
            fromInv={0}
            proc_id={0}
          />
        }
        {infoPrint ?  <RevAccounting dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> :null}
      </Typography>
    </div>
  );
}
